module.exports = __webpack_public_path__ + "img/camel-logo.103e6465.svg";